import {
  Component,
  Inject,
  PLATFORM_ID,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CommonUtilService } from '../../../services/common-util/common-util.service';
import { RouterOutlet } from '@angular/router';
// import { DpTabMenuComponent } from '../../../common-component/dp-tab-menu/dp-tab-menu.component';
import { DpTabMenuV3Component } from '../../../common-component/dp-tab-menu-v3/dp-tab-menu-v3.component';
@Component({
  selector: 'app-dpnf',
  standalone: true,
  imports: [
    RouterOutlet, DpTabMenuV3Component
  ],
  templateUrl: './dpnf.component.html',
  styleUrls: ['./dpnf.component.scss']
})
export class DpnfComponent {
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _ismobileservice: CommonUtilService,
  ) { }
  public isMobile: boolean = false;
  ngOnInit() {
    this.isMobile = this._ismobileservice.isMobileDevice();
  }
  isMobileBrowser(): boolean {
    const userAgent = isPlatformBrowser(this.platformId)
      ? window.navigator.userAgent
      : '';
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      userAgent
    );
  }
}
